// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".portfolio-header .header[data-v-3bc00688]{min-height:800px}@media screen and (max-width:767px){.portfolio-header .header[data-v-3bc00688]{height:auto;min-height:0;min-height:auto;padding:140px 15px}}.portfolio-header .icon-page-link[data-v-3bc00688]{align-items:center;display:flex;gap:10px}.portfolio-header .icon-link[data-v-3bc00688]{height:10px;width:10px}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
module.exports = ___CSS_LOADER_EXPORT___;
